"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getLanguage;
var _locales = require("./locales");
function getLanguage() {
  const lang = document.querySelector("html").getAttribute("lang") || _locales.locales.en;
  return _locales.locales[lang] ? lang : _locales.locales.en;
}